/**
 * @generated SignedSource<<3c375bdb479443691a75caee8a6a0d48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveContentLoaderQuery$variables = {
  entityUuid?: string | null | undefined;
  randomString?: string | null | undefined;
};
export type liveContentLoaderQuery$data = {
  readonly liveArticle: {
    readonly liveContents: ReadonlyArray<{
      readonly customTime: number | null | undefined;
      readonly entityId: string;
      readonly entityUuid: string;
      readonly " $fragmentSpreads": FragmentRefs<"summaryLiveArticleSummaryLiveContent" | "timelineLiveArticleLiveContent">;
    } | null | undefined> | null | undefined;
    readonly status: boolean | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"contentLiveArticleLiveArticle" | "liveUpdateSwitchLiveArticle">;
  } | null | undefined;
};
export type liveContentLoaderQuery = {
  response: liveContentLoaderQuery$data;
  variables: liveContentLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "randomString"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityUuid",
        "variableName": "entityUuid"
      },
      {
        "kind": "Variable",
        "name": "randomString",
        "variableName": "randomString"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customTime",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "liveContentLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LiveContent",
            "kind": "LinkedField",
            "name": "liveContents",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "summaryLiveArticleSummaryLiveContent"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "timelineLiveArticleLiveContent"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "contentLiveArticleLiveArticle"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "liveUpdateSwitchLiveArticle"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "liveContentLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LiveContent",
            "kind": "LinkedField",
            "name": "liveContents",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Author",
                "kind": "LinkedField",
                "name": "authors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "json",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pushNotifications",
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2b385d2608bee2db3e69ae7a0a85fa30",
    "id": null,
    "metadata": {},
    "name": "liveContentLoaderQuery",
    "operationKind": "query",
    "text": "query liveContentLoaderQuery(\n  $entityUuid: String\n  $randomString: String\n) {\n  liveArticle(filter: {entityUuid: $entityUuid, randomString: $randomString}) {\n    status\n    liveContents {\n      entityId\n      entityUuid\n      customTime\n      ...summaryLiveArticleSummaryLiveContent\n      ...timelineLiveArticleLiveContent\n    }\n    ...contentLiveArticleLiveArticle\n    ...liveUpdateSwitchLiveArticle\n    id\n  }\n}\n\nfragment contentLiveArticleLiveArticle on LiveArticle {\n  liveContents {\n    customTime\n    entityUuid\n    ...itemLiveArticleContentLiveContent\n  }\n}\n\nfragment contentShareWidgetLiveContent on LiveContent {\n  title\n  entityId\n  body {\n    text\n  }\n}\n\nfragment itemLiveArticleContentLiveContent on LiveContent {\n  customTime\n  entityId\n  entityUuid\n  title\n  authors {\n    name\n    id\n  }\n  summary {\n    text\n  }\n  body {\n    json\n  }\n  ...contentShareWidgetLiveContent\n}\n\nfragment itemLiveArticleSummaryLiveContent on LiveContent {\n  entityUuid\n  customTime\n  summary {\n    text\n  }\n}\n\nfragment itemLiveArticleTimelineLiveContent on LiveContent {\n  entityUuid\n  customTime\n  title\n}\n\nfragment liveUpdateSwitchLiveArticle on LiveArticle {\n  status\n  pushNotifications\n}\n\nfragment summaryLiveArticleSummaryLiveContent on LiveContent {\n  customTime\n  entityUuid\n  summary {\n    text\n  }\n  ...itemLiveArticleSummaryLiveContent\n}\n\nfragment timelineLiveArticleLiveContent on LiveContent {\n  customTime\n  entityUuid\n  ...itemLiveArticleTimelineLiveContent\n}\n"
  }
};
})();

(node as any).hash = "fe15e85c8bce5450e2db67bd8475d20d";

export default node;
